<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>For my son John Michael</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?4648f72a